var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),(_vm.world)?_c('animation',{attrs:{"fn":_vm.animate}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }